// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__1JeZt","homeHeroImg":"Home_homeHeroImg__3dekp","homeText":"Home_homeText__azxDe"};